var React = require('react');

function TextQuarterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.1","d":"M0.999996 370C0.999996 166.207 165.759 1 369 1","stroke":"#F9F8F2"}));
}

TextQuarterInline.defaultProps = {"viewBox":"0 0 369 370","fill":"none"};

module.exports = TextQuarterInline;

TextQuarterInline.default = TextQuarterInline;
